import type { UserRecentProjectsAndContestsEntry } from './user-recent-projects-and-contests.model';
import type { Contest } from '../contests/contests.model';
import type { Project } from '../projects/projects.model';

export interface GenerateRecentProjectsAndContestsOptions {
  readonly projects?: readonly Project[];
  readonly contests?: readonly Contest[];
}

export function generateRecentProjectsAndContestsObjects({
  projects = [],
  contests = [],
}: GenerateRecentProjectsAndContestsOptions): readonly UserRecentProjectsAndContestsEntry[] {
  const recentProjects = projects.map(
    ({ id, title, seoUrl, timeSubmitted }) => ({
      id: `project-${id}`,
      type: 'project' as const,
      latest: timeSubmitted,
      name: title,
      projectOrContestId: id,
      urlPart: `/projects/${seoUrl}`,
    }),
  );

  const recentContests = contests.map(
    ({ id, title, seoUrl, timeSubmitted }) => ({
      id: `contest-${id}`,
      type: 'contest' as const,
      latest: timeSubmitted || Date.now(),
      name: title,
      projectOrContestId: id,
      urlPart: `/contests/${seoUrl}`,
    }),
  );

  return [...recentProjects, ...recentContests];
}
